import { Typography } from "antd";

// REACT_APP_VERSION is set to $npm_package_version in every .env.* file, so builds show
// the package.json version (bumped per PR into develop by .github/workflows/version-bump.yml).
const AppFooter = () => {
  const version = process.env.REACT_APP_VERSION;

  if (!version) return null;

  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      v{version}
    </Typography.Text>
  );
};

export default AppFooter;
